import { cn } from "@/lib/utils";

type AccentColor = "orange" | "amber" | "green" | "critical" | "warning" | "healthy";

const accentColors: Record<AccentColor, string> = {
  orange: "border-l-copilot-accent-orange",
  amber: "border-l-copilot-accent-amber",
  green: "border-l-copilot-accent-green",
  critical: "border-l-copilot-critical",
  warning: "border-l-copilot-warning",
  healthy: "border-l-copilot-healthy",
};

interface AccentCardProps {
  accent: AccentColor;
  children: React.ReactNode;
  className?: string;
}

export function AccentCard({ accent, children, className }: AccentCardProps) {
  return (
    <div
      className={cn(
        "bg-white border border-transparent rounded-[var(--card-radius)] p-[var(--space-md)] shadow-sm",
        "border-l-4",
        accentColors[accent],
        className
      )}
    >
      {children}
    </div>
  );
}
